import { render, staticRenderFns } from "./InfrastructureView.vue?vue&type=template&id=31ad4dc0&scoped=true"
import script from "./InfrastructureView.vue?vue&type=script&lang=js"
export * from "./InfrastructureView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad4dc0",
  null
  
)

export default component.exports